import { useState } from "react";

import CheckIcon from "../../../../components/CheckIcon";
import Dialog from "./Dialog";

const AcceptButton = ({ companyId, companyName }) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	return (
		<>
			<CheckIcon onClick={handleClickOpen} />
			<Dialog
				open={open}
				onClose={handleClose}
				companyId={companyId}
				companyName={companyName}
			/>
		</>
	);
};

export default AcceptButton;
